import * as React from 'react';
import { Body1 } from '@cian/ui-kit';
import * as style from './style.css';

import { ITransportDistanceCell } from '../../../../../../types/newbuildingsCompare';
import { transportTypeIconMapper } from '../shared/transportIcons';

export interface ITransportDistanceCellProps {
  cell: ITransportDistanceCell;
}

/**
 * Строка «Расстояние до метро, шоссе» мобильной таблицы. Порядок расстояний совпадает с порядком
 * точек в строке transportPoint — бэк строит оба списка из одних и тех же метро и шоссе.
 *
 * Иконку транспорта показываем только там, где бэк прислал transportType: у расстояний до шоссе
 * («5 км от МКАД») и у заглушки «Нет данных» его нет.
 */
export const TransportDistanceCell = ({ cell }: ITransportDistanceCellProps): React.JSX.Element => {
  const transportDistances = cell.data?.transportDistances;

  if (!transportDistances?.length) {
    return (
      <div className={style['container']}>
        <Body1 color="text-primary-disabled">{cell.state.text ?? ''}</Body1>
      </div>
    );
  }

  return (
    <div className={style['container']}>
      {transportDistances.map((transportDistance, index) => (
        <div className={style['distance']} key={`${transportDistance.distance}-${index}`}>
          {transportDistance.transportType && (
            <div className={style['icon']}>{transportTypeIconMapper(transportDistance.transportType)}</div>
          )}
          <Body1 color="text-primary-default">{transportDistance.distance}</Body1>
        </div>
      ))}
    </div>
  );
};
